// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active {
    color: var(--foreground-text-hover-color)!important;
    background-color: var(--primary-color);
}
.active:hover {
    color: var(--foreground-text-hover-color);
    background-color: var(--primary-color) !important;
}
.appswitchbutton:hover {
    color: var(--foreground-text-hover-color);
    background-color: var(--primary-color) !important;
}
.appswitchbutton {
    color: var(--foreground-text-color);
    /*background-color: var(--primary-color) !important;*/
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/appswitch/appswitch.component.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;IACnD,sCAAsC;AAC1C;AACA;IACI,yCAAyC;IACzC,iDAAiD;AACrD;AACA;IACI,yCAAyC;IACzC,iDAAiD;AACrD;AACA;IACI,mCAAmC;IACnC,qDAAqD;AACzD","sourcesContent":[".active {\n    color: var(--foreground-text-hover-color)!important;\n    background-color: var(--primary-color);\n}\n.active:hover {\n    color: var(--foreground-text-hover-color);\n    background-color: var(--primary-color) !important;\n}\n.appswitchbutton:hover {\n    color: var(--foreground-text-hover-color);\n    background-color: var(--primary-color) !important;\n}\n.appswitchbutton {\n    color: var(--foreground-text-color);\n    /*background-color: var(--primary-color) !important;*/\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
